// extracted by mini-css-extract-plugin
export default {"name":"UserName_name__B7bmc","empty":"UserName_empty__XnXUC"};